import { IProductDTO } from '@legacy/shared-types/dto/product.type';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { productApi } from '@api/product/productsApi';

export const useProductById = (id?: string): UseQueryResult<IProductDTO> =>
  useQuery(['products-list', id], () => (id ? productApi.getProductById(id) : {}), {
    enabled: !!id,
  });
